/**
 * TODO
 * - RWD
 */
const MAX_LEVEL = 9;
const ADD_CELL_INTERVAL_SECONDS = 6;
const WAIT_CELL_TIMEOUT_SECONDS = 5;
const TAP_CELL_TIMEOUT_SECONDS = 3;
const CELL_WAIT = "wait";
const CELL_TAP = "tap";
const CELL_DONE = "done";
const CELL_DEAD = "dead";
import "./game.css";
import * as React from "react";
import classNames from "classnames";
import CtaButton from "../ctaButton/ctaButton";

function getAvailableWindowSize() {
  const availHeight = 200; //window.innerHeight - 200; // ~ title height… FIXME.
  return window.innerWidth > availHeight ? availHeight : window.innerWidth;
}

function range(n) {
  return Array.apply(0, Array(n)).map(function (_, i) {
    return i;
  });
}

function slice(list, ...args) {
  return [].slice.apply(list, [].slice.call(args, 1));
}

function replaceAt(list: any[], index, value) {
  // hint: splice sucks balls.
  const start = slice(list);
  const end = slice(list);

  return list.map((e, idx) => (idx === index ? value : e));
}

const gameData = (function () {
  let _cells = [],
    _changeListeners = [];

  function _findOffIndexes() {
    return _cells.reduce(function (indexes, cell, i) {
      return cell.type === "off" ? indexes.concat(i) : indexes;
    }, []);
  }

  function _setCells(cells) {
    _cells = cells;
    _changeListeners.forEach(function (listener) {
      listener();
    });
  }

  return {
    getCells: function () {
      return _cells;
    },
    addChangeListener: function (listener) {
      _changeListeners.push(listener);
    },
    removeChangeListener: function (listener) {
      _changeListeners = _changeListeners.filter(function (aListener) {
        return aListener !== listener;
      });
    },
    initCells: function (numberOfCells) {
      _setCells(
        range(numberOfCells).map(function () {
          return { type: "off" };
        })
      );
    },
    activateNewCell: function () {
      const offIndexes = _findOffIndexes();
      if (offIndexes.length === 0) return false;
      const randomIndex = Math.floor(Math.random() * offIndexes.length);
      const swapIndex = offIndexes[randomIndex];
      _setCells(replaceAt(_cells, swapIndex, { type: CELL_WAIT }));
      return true;
    },
    switchCellTo: function (cell, type) {
      _setCells(
        _cells.map(function (aCell) {
          return aCell === cell ? { type: type } : aCell;
        })
      );
    },
    freezeCells: function () {
      _setCells(
        _cells.map(function (aCell) {
          if (aCell.type === CELL_TAP || aCell.type === CELL_WAIT)
            return { type: CELL_DONE };
          return aCell;
        })
      );
    },
    checkGridComplete: function () {
      return _findOffIndexes().length === 0;
    },
  };
})();

const TimerMixin = {
  getDefaultProps: function () {
    return { countdown: 3 };
  },
  getInitialState: function () {
    return { countdown: parseInt(this.props.countdown, 10) };
  },
  componentDidMount: function () {
    this._timer = setInterval(this.onSecondElapsed, 1000);
  },
  componentWillUnmount: function () {
    this.cancelTimer();
  },
  cancelTimer: function () {
    if (this._timer) clearInterval(this._timer);
  },
  onSecondElapsed: function () {
    if (this.state.countdown > 1) {
      return this.setState({ countdown: this.state.countdown - 1 });
    }
    this.cancelTimer();
    this.props.onTimeout(this.props.cell);
  },
};

interface CellProps {
  onClick?: (string) => void;
  cell: any;
  size: number;
  label?: string;
  countdown?: string;
}

class Cell extends React.Component<CellProps> {
  static defaultProps = { size: 48 };

  handleClick = (event) => {
    event.preventDefault();
    if (this.props.onClick) {
      this.props.onClick(this.props.cell);
    }
  };
  _getStyle = () => {
    return {
      width: this.props.size,
      height: this.props.size,
      fontSize: Math.round(this.props.size / 4) + "px",
      lineHeight: Math.round(this.props.size / 2.2) + "px",
    };
  };
  render = () => {
    const classes = { cell: true };
    classes[this.props.cell.type || "off"] = true;
    return (
      <div
        className={classNames(classes)}
        onClick={this.handleClick}
        style={this._getStyle()}
      >
        <div className="inner">
          {this.props.label ? <p>{this.props.label}</p> : null}
          {this.props.countdown ? <p>{this.props.countdown}</p> : null}
        </div>
      </div>
    );
  };
}

interface WaitCellProps {
  size?: number;
  cell?: any;
  countdown?: any;
  onTimeout?: (any) => void;
}
interface WaitCellState {
  countdown: any;
  timer?: any;
}

class WaitCell extends React.Component<WaitCellProps, WaitCellState> {
  intervalID: NodeJS.Timeout;

  timer = () => {
    this.intervalID = setInterval(this.onSecondElapsed, 1000);
  }
  defaultProps = { countdown: 3 };
  
  constructor(props:WaitCellProps) {
    super(props)
    this.state={ countdown: parseInt(this.props.countdown, 10) };
  }
  componentDidMount = () => {
    this.timer;
  };
  componentWillUnmount = () => {
    this.cancelTimer();
  };
  cancelTimer = () => {
    if (this.timer) clearInterval(this.intervalID);
  };
  onSecondElapsed = () => {
    if (this.state.countdown > 1) {
      return this.setState({ countdown: this.state.countdown - 1 });
    }
    this.cancelTimer();
    this.props.onTimeout(this.props.cell);
  };

  render = () => {
    return (
      <Cell
        cell={this.props.cell}
        size={this.props.size}
        label="WAIT"
        countdown={this.state.countdown}
      />
    );
  };
}

interface TapCellProps {
  size?: number;
  cell?: any;
  countdown?: any;
  onTapped?: any;
  onTimeout?: (any) => void;
}
interface TapCellState {
  countdown?: any;
}

class TapCell extends React.Component<TapCellProps, TapCellState> {
  intervalID: NodeJS.Timeout;
  timer = () => {
    this.intervalID = setInterval(this.onSecondElapsed, 1000);
  }
  defaultProps ={ countdown: 3 };

  constructor(props:TapCellProps){
    super(props)
    this.state={ countdown: parseInt(this.props.countdown, 10) };
  }
  componentDidMount = () => {
    this.timer;
  };
  componentWillUnmount = () => {
    this.cancelTimer();
  };
  cancelTimer = () => {
    if (this.timer) clearInterval(this.intervalID);
  };
  onSecondElapsed = () => {
    if (this.state.countdown > 1) {
      return this.setState({ countdown: this.state.countdown - 1 });
    }
    this.cancelTimer();
    this.props.onTimeout(this.props.cell);
  };

  render = () => {
    return (
      <Cell
        cell={this.props.cell}
        size={this.props.size}
        label="TAP"
        onClick={this.props.onTapped}
        countdown={this.state.countdown}
      />
    );
  };
}

interface OverlayProps {
  onButtonClick?: () => void;
  cell?: any;
  title?: string;
  buttonLabel?: string;
}

class Overlay extends React.Component<OverlayProps> {
  clickFullScreen = (event) => {
    event.preventDefault();
  };

  render = () => {
    return (
      <div className="overlay">
        <h1>{this.props.title}</h1>
        {this.props.children}
        <CtaButton
          text={this.props.buttonLabel || "Start"}
          width={"280px"}
          color="blue"
          onClick={this.props.onButtonClick}
        />
      </div>
    );
  };
}

interface GridProps {
  level: number;
  gameState: string;
  incrementScore: () => void;
  nextLevel: () => void;
  gameOver: () => void;
}

interface GridState {
  cells: any;
  level: any;
}

class Grid extends React.Component<GridProps, GridState> {
  defaultProps ={ level: 1 };
  _addCellTimer: NodeJS.Timeout;

  constructor(props:GridProps) {
    super(props)
    this.state={ level: this.props.level, cells: [] };
  }
  componentDidMount = () => {
    gameData.addChangeListener(this.onStoreChanged);
    gameData.initCells(this._getNumberOfCells());
  };
  componentWillUnmount = () => {
    gameData.removeChangeListener(this.onStoreChanged);
    clearInterval(this._addCellTimer);
  };
  onStoreChanged = () => {
    this.setState({ cells: gameData.getCells() });
  };
  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (
      this.props.gameState !== "ongoing" &&
      nextProps.gameState === "ongoing"
    ) {
      this.setState({ level: nextProps.level }, this.initiateGrid);
    }
  };
  _getNumberOfCells = () => {
    const size = this.props.level + 1;
    return size * size;
  };
  initiateGrid = () => {
    gameData.initCells(this._getNumberOfCells());
    this._addCellTimer = setInterval(
      this.activateNewCell,
      ADD_CELL_INTERVAL_SECONDS * 1000
    );
    this.activateNewCell();
  };
  activateNewCell = () => {
    if (!gameData.activateNewCell()) return this.nextLevel();
  };
  onCellTapped = (cell) => {
    this.props.incrementScore();
    if (gameData.checkGridComplete()) return this.nextLevel();
    gameData.switchCellTo(cell, CELL_WAIT);
  };
  onCellTimeout = (cell) => {
    if (cell.type === CELL_TAP) {
      gameData.switchCellTo(cell, CELL_DEAD);
      this.gameOver(cell);
    } else {
      gameData.switchCellTo(cell, CELL_TAP);
    }
  };
  gameOver = (failedCell) => {
    clearInterval(this._addCellTimer);
    gameData.freezeCells();
    this.props.gameOver();
  };
  nextLevel = () => {
    clearInterval(this._addCellTimer);
    gameData.freezeCells();
    this.props.nextLevel();
  };
  _getCellComponent = (cell, key) => {
    const cellSize = Math.floor(
      getAvailableWindowSize() / Math.sqrt(this._getNumberOfCells())
    );
    switch (cell.type) {
      case CELL_WAIT: {
        return (
          <WaitCell
            key={key}
            cell={cell}
            size={cellSize}
            countdown={WAIT_CELL_TIMEOUT_SECONDS}
            onTimeout={this.onCellTimeout}
          />
        );
      }
      case CELL_TAP: {
        return (
          <TapCell
            key={key}
            cell={cell}
            size={cellSize}
            countdown={TAP_CELL_TIMEOUT_SECONDS}
            onTimeout={this.onCellTimeout}
            onTapped={this.onCellTapped}
          />
        );
      }
      default: {
        return <Cell key={key} cell={cell} size={cellSize} />;
      }
    }
  };
  _getStyle = () => {
    return {
      width: getAvailableWindowSize(),
      margin: "0 auto",
    };
  };
  render = () => {
    return (
      <div className="grid" style={this._getStyle()}>
        {this.state.cells.map(function (cell, i) {
          return this._getCellComponent(cell, i);
        }, this)}
      </div>
    );
  };
}

interface GameProps {
  level: any;
}
interface GameState {
  gameState: string;
  level: any;
  score: number;
  best: () => void;
}

export class Game extends React.Component<GameProps, GameState> {
  static defaultProps = { level: 1 }
  
  constructor(props:GameProps){
    super(props);
    this.state={
      gameState: "init",
      level: this.props.level,
      score: 0,
      best: localStorage["swwwitch.best"] || 0,
    };
  }
  

  startGame = () => {
    this.setState({
      gameState: "ongoing",
      level: 1,
      score: 0,
    });
  };
  startNextLevel = () => {
    const nextLevel = this.state.level + 1;
    if (nextLevel > MAX_LEVEL) {
      return this.winGame();
    }
    this.setState({
      gameState: "ongoing",
      level: nextLevel,
    });
  };
  nextLevel = () => {
    this.setState({ gameState: "levelup" });
  };
  incrementScore = () => {
    const newScore = this.state.score + 1;
    this.setState({ score: newScore, best: this._computeBest(newScore) });
  };
  winGame = () => {
    this.setState({ gameState: "win" });
  };
  gameOver = () => {
    this.setState({ gameState: "over" });
  };
  _computeBest = (score) => {
    const best = this.state.best;
    if (score > best) {
      localStorage["swwwitch.best"] = score;
      return score;
    }
    return best;
  };
  _renderOverlay = () => {
    switch (this.state.gameState) {
      case "init": {
        return (
          <Overlay title="How to play?" onButtonClick={this.startGame}>
            <p>Tap a tile when it turns green.</p>
            <p>You win when no more tile is available.</p>
            <p>Don’t miss any or the game ends!</p>
          </Overlay>
        );
      }
      case "levelup": {
        return (
          <Overlay
            title={"Level " + this.state.level + " completed!"}
            buttonLabel="Start next level"
            onButtonClick={this.startNextLevel}
          >
            <p>Get ready!</p>
          </Overlay>
        );
      }
      case "over":
      case "win": {
        return (
          <Overlay
            title={this.state.gameState === "win" ? "You won!" : "Game Over."}
            onButtonClick={this.startGame}
          >
            <p>You scored {this.state.score} point(s).</p>
          </Overlay>
        );
      }
      default:
        return <div></div>;
    }
  };
  render = () => {
    return (
      <div className="game">
        <h2 className="TITLE_2" style={{ paddingBottom: 30 }}>
          Level: {this.state.level} — Score: {this.state.score} — Best:{" "}
          {this.state.best}
        </h2>
        <Grid
          level={this.state.level}
          incrementScore={this.incrementScore}
          gameState={this.state.gameState}
          nextLevel={this.nextLevel}
          gameOver={this.gameOver}
        />
        {this._renderOverlay()}
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/screens/game.tsx